import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_ESUS,
    useChartsData
} from '../../../Common/Filters/useChartsData';

export const HouseHoldVisitChartsDataContext = createContext();

const HouseHoldVisitChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_ESUS.PRODUCTION_HOUSEHOLD_VISIT,
            url: 'governanceroom/esus/production/hoseholdvisit'
        },
        {
            year: filters.ano.value,
            month: filters.competencia.map((competencia) => competencia.value),
            location: filters.unidade.value,
            household_status: filters.household_status.map(
                (item) => item.value
            ),
            city: filters.cidade?.governance_room_geo_city_id,
        }
    );


    const chartData = data
        ? {
              indicators: {
                  totalHouseHold: data?.indicators?.totalHouseHold ?? 0
              },
              evolutionHouseVisitByCoordinates:
                  data?.evolutionHouseVisitByCoordinates ?? [],
              annualEvolutionHouseHoldVisit:
                  data?.annualEvolutionHouseHoldVisit ?? [],
              monthlyEvolutionHouseHoldVisit:
                  data?.monthlyEvolutionHouseHoldVisit ?? [],
              evolutionByHouseHoldStatus: data?.evolutionByHouseHoldStatus ?? []
          }
        : {
              indicators: {
                  totalHouseHold: 0
              },
              evolutionHouseVisitByCoordinates: [],
              annualEvolutionHouseHoldVisit: [],
              monthlyEvolutionHouseHoldVisit: [],
              evolutionByHouseHoldStatus: []
          };

    return (
        <HouseHoldVisitChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </HouseHoldVisitChartsDataContext.Provider>
    );
};

export default HouseHoldVisitChartsDataProvider;
